import React from "react";
import { Hero } from "./Hero";
import { Services } from "./Services";

const index = () => {
  return (
    <div>
      <Hero />
      <Services />
    </div>
  );
};

export default index;
